import { createSlice } from '@reduxjs/toolkit'

const reducer = createSlice({
  name: 'dashboard',
  initialState: {
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload })
  },
}).reducer

const actions = (dis, store, restClient) => {
  function addGroup(groupId) {
    const {
      dashboard: { id },
    } = store.getState()
    return restClient.post(`/api/dashboards/${id}/groups`, { groupId }).then(({ data }) => {
      dis({ type: 'dashboard/upsert', payload: { groups: data } })
    })
  }

  function removeGroup(groupId) {
    const {
      dashboard: { id },
    } = store.getState()
    return restClient.delete(`/api/dashboards/${id}/groups/${groupId}`).then(({ data }) => {
      dis({ type: 'dashboard/upsert', payload: { groups: data } })
    })
  }

  function updateSetting(key, value) {
    const { dashboard } = store.getState()
    const settings = { ...(dashboard.settings || {}), [key]: value }
    return dis({ type: 'dashboard/upsert', payload: { settings } })
  }

  return {
    set: (payload) => {
      dis({ type: 'dashboard/set', payload })
    },
    upsert: (payload) => {
      dis({ type: 'dashboard/upsert', payload })
    },
    addGroup,
    removeGroup,
    updateSetting,
  }
}

export { reducer, actions }
export default { reducer, actions }
